module.exports = __webpack_public_path__ + "static/img/ex_b2.b04b467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_b2.jpg
// module id = EZaZ
// module chunks = 1